import { Educations } from '../../consts/const-utils';

export const getOrCreateTooltip = (chart) => 
{  
  let tooltipEl = chart.canvas.parentNode.querySelector('.custom-tooltip');

  if (!tooltipEl)
  {
    tooltipEl = document.createElement('div');
    tooltipEl.className = "custom-tooltip";
    tooltipEl.style.pointerEvents = 'none';

    const table = document.createElement('table');
    table.style.margin = '0px';

    tooltipEl.appendChild(table);
    chart.canvas.parentNode.appendChild(tooltipEl);
  }

  return tooltipEl;
};

export const getOrCreateTooltipCustom = (chart) => 
{  
  let tooltipEl = chart.canvas.parentNode.querySelector('.custom-tooltip-2');

  if (!tooltipEl)
  {
    tooltipEl = document.createElement('div');
    tooltipEl.className = "custom-tooltip-2";
    tooltipEl.style.pointerEvents = 'none';

    const wrapper = document.createElement('div');
    wrapper.className = 'tooltip-content';
    tooltipEl.appendChild(wrapper);
    chart.canvas.parentNode.appendChild(tooltipEl);
  }

  return tooltipEl;
};

export const externalTooltipHandler = (context, statsHTML) => {

  // Tooltip Element
  const {chart, tooltip} = context;

  const tooltipEl = getOrCreateTooltip(chart);

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }

  // Set Text
  if (tooltip.body)
  {
    const titleLines = tooltip.title || [];

    const bodyLines = tooltip.body.map(b => b.lines);


    const tableHead = document.createElement('thead');

    titleLines.forEach(title => 
    {
      const tr = document.createElement('tr');
      tr.style.borderWidth = 0;

      const th = document.createElement('th');
      th.style.borderWidth = 0;
      const text = document.createTextNode(title);

      th.appendChild(text);
      tr.appendChild(th);
      tableHead.appendChild(tr);

    });

    const tableBody = document.createElement('tbody');

    bodyLines.forEach((body, i) => 
    {
      const colors = tooltip.labelColors[i];

      const span = document.createElement('span');
      span.style.background = colors.backgroundColor;
      span.style.borderColor = colors.borderColor;
      span.style.borderWidth = '2px';
      span.style.marginRight = '10px';
      span.style.height = '10px';
      span.style.width = '10px';
      span.style.display = 'inline-block';

      const tr = document.createElement('tr');
      tr.style.backgroundColor = 'inherit';
      tr.style.borderWidth = 0;

      const td = document.createElement('td');
      td.style.borderWidth = 0;


      let roundedNumber = body; // body contains value

      // Check if string or body is is comma separated
      const bodyArray = body[0].split(":");
      if(bodyArray.length == 2)
      {
        roundedNumber = parseFloat(bodyArray[1].trim().replace(",",".")); 
      }
      else{
        roundedNumber = body[0].replace(",", ".");
      }


      var newRoundedNumber = Math.round(roundedNumber);


      const text = document.createTextNode(`${newRoundedNumber} kr.`);

      td.appendChild(span);


      td.appendChild(text);

      tr.appendChild(td);

      // Stats row
      const tdStats = document.createElement('td');
      const divStats = document.createElement("div");
      divStats.innerHTML = statsHTML
      tdStats.appendChild(divStats);


      const trStats = document.createElement('tr');
      trStats.appendChild(tdStats);

      tableBody.appendChild(tr);
      tableBody.appendChild(trStats);
    });

    const tableRoot = tooltipEl.querySelector('table');

    
    // Remove old children
    while (tableRoot.firstChild) {
      tableRoot.firstChild.remove();
    }

    // Add new children
    tableRoot.appendChild(tableHead);
    tableRoot.appendChild(tableBody);
  }

  const {
    offsetLeft: positionX, 
    offsetTop: positionY
  } = chart.canvas;

  const slightOffset = 10;

  // Display, position, and set styles for font
  tooltipEl.style.opacity = 1;

  tooltipEl.style.top = positionY + tooltip.caretY + 10 + 'px';  

  const tooltipSpace = chart.canvas.getBoundingClientRect().left + tooltip.caretX + tooltipEl.clientWidth;

  if(tooltipSpace < window.innerWidth)
  {
    tooltipEl.style.left = positionX + tooltip.caretX + slightOffset  + 'px';
  }
  else{
    tooltipEl.style.left = positionX + tooltip.caretX - slightOffset - 200 + 'px';;
  }
  
  
  tooltipEl.style.font = tooltip.options.bodyFont.string;
  tooltipEl.style.padding = tooltip.options.padding + 'px ' + tooltip.options.padding + 'px';
};

export const externalTooltipHandlerCustom = (context, pointTitle, pointValue) => 
{
  // Tooltip Element
  const {chart, tooltip} = context;

  const tooltipEl = getOrCreateTooltipCustom(chart);

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }

  // Set Text
  if (tooltip.body)
  {
    const titleLines = tooltip.title || [];

    const bodyLines = tooltip.body.map(b => b.lines);

    const headline = document.createElement('h4');

    titleLines.forEach(title => 
    {
      const text = document.createTextNode(title);
      headline.appendChild(text);
    });

    const ul = document.createElement('ul');
    bodyLines.forEach((body, i) => 
    {
      const colors = tooltip.labelColors[i];

      const li = document.createElement('li');
      li.innerHTML = 
      `<span class="point-label" style="border-color: ${colors.backgroundColor};">
      ${pointTitle && pointValue ? `<span>${pointTitle}</span> <span>${pointValue}</span>` : body}
      </span>`;
      ul.appendChild(li);
    });

    const wrapper = tooltipEl.querySelector('.tooltip-content');

     
    // Remove old children
    while (wrapper.firstChild) {
      wrapper.firstChild.remove();
    } 

    // Add new children
    wrapper.appendChild(headline);
    wrapper.appendChild(ul);
  }

  const {
    offsetLeft: positionX, 
    offsetTop: positionY
  } = chart.canvas;

  const slightOffset = 10;

  // Display, position, and set styles for font
  tooltipEl.style.opacity = 1;

  const tooltipSpace = chart.canvas.getBoundingClientRect().left + tooltip.caretX + tooltipEl.clientWidth;

  if(tooltipSpace < window.innerWidth)
  {
    tooltipEl.style.left = positionX + tooltip.caretX + slightOffset  + 'px';
  }
  else{
    tooltipEl.style.left = positionX + tooltip.caretX - slightOffset - 200 + 'px';;
  }


  tooltipEl.style.top = positionY + tooltip.caretY + 10 + 'px';  
  tooltipEl.style.font = tooltip.options.bodyFont.string;
  

};


export const getTooltipStatistics = (context, dataStatisticsExperience) => 
{
    var html = ``;  
    const { tooltip} = context;
    const title = tooltip.title ? tooltip.title[0] : "";
  
    dataStatisticsExperience && dataStatisticsExperience.Sheet1.forEach((p) => 
    {
      if(p.Group === title && p.Education)
      {
        let educationKeys =  Object.keys(p.Education).filter(e => 
        {
            if(e != 'Group' && e != 'Color') return true
            else return false
        });
        let educationText = ``;
        let educationPhrase = ``;
      


        // generate education text based on amount of educations and percentage
        educationKeys.forEach((eduKey, index) => 
        {

          const educationName = Educations.filter(e => e.shortname === eduKey)[0];

          educationText += `${educationName.name}`;
          
          if((index + 2) < educationKeys.length)
          {
            educationText += `, en `;
          }
          else if((index + 1) < educationKeys.length)
          {
            educationText += ` eller en `;
          }

/*           let percentage = p.Education[eduKey];
          percentage = parseInt(percentage);
          
          if(percentage <= 80)
          {
            educationPhrase = `typisk `
          } */
        })

        // put it all together
        html = `<div class="stats-text">${p.Group} har typisk ${p.WorkExperience.replace('.',',')} års erhvervserfaring, er ${p.Age ? Math.round(p.Age) : null} år og har typisk en ${educationText.toLowerCase()}</div>`;
      }
    })
  
    return html;
  }


export const externalTooltipHandlerFordelingstal = (context, dataAccumulatedStats, salaryGroup) => 
{
  // Tooltip Element
  const {chart, tooltip} = context;

  const tooltipEl = getOrCreateTooltipCustom(chart);

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }


  // Set Text
  if (tooltip.body)
  {
    const bodyLines = tooltip.body.map(b => b.lines);

    const uniqueBodyLines = [];

    bodyLines.forEach(bodyLine =>
    {
      bodyLine.forEach(line =>
      {
        if(!uniqueBodyLines.includes(line))
        {
          uniqueBodyLines.push(line);
        }
      })
    }); 

    var li = ``;

    uniqueBodyLines.forEach((b, i) => 
    {
        const colors = tooltip.labelColors[i];
        const myArray = b.split(":");
        var pointValue = parseFloat(myArray[1].trim().replace(",", "."));

        var groupName = myArray[0];

        // Find accumulated percent
        var percentageAccumulated = null;

        if(dataAccumulatedStats)
        {
          const selectedStat = dataAccumulatedStats[salaryGroup].filter(g => g.Group === groupName);
          if(selectedStat && selectedStat[0] != null)
          {
            const label =  tooltip.dataPoints[0].label;
            percentageAccumulated = selectedStat[0][label];
          }          
        }
        // end of accumulated percent


        li += `<li><span class="line-color" style="background-color: ${colors.borderColor}"></span>
        ${formatDecimal(pointValue)}% af alle 
        <span class="type"> ${groupName.trim().toLowerCase()} </span> tjener ${tooltip.title} kr. i timen 
        ${percentageAccumulated != null ? ` og ${formatDecimal(percentageAccumulated)}% af alle ${groupName.trim().toLowerCase()} tjener mindst ${tooltip.title} kr. i timen.`: ``}
        </li>
        `;
    });

    const ul = document.createElement('ul');
    ul.innerHTML = li;

    const wrapper = tooltipEl.querySelector('.tooltip-content');

    // Remove old children
    while (wrapper.firstChild) {
      wrapper.firstChild.remove();
    } 

    // Add new children
    wrapper.appendChild(ul);
  }

  const {
    offsetLeft: positionX, 
    offsetTop: positionY
  } = chart.canvas;

  const slightOffset = 10;

  // Display, position, and set styles for font
  tooltipEl.style.opacity = 1;


  const tooltipSpace = chart.canvas.getBoundingClientRect().left + tooltip.caretX + tooltipEl.clientWidth;

  if(tooltipSpace < window.innerWidth)
  {
    tooltipEl.style.left = positionX + tooltip.caretX + slightOffset  + 'px';
  }
  else{
    tooltipEl.style.left = positionX + tooltip.caretX - slightOffset - 200 + 'px';;
  }


  tooltipEl.style.top = positionY + tooltip.caretY + 10 + 'px';  
  
  tooltipEl.style.font = tooltip.options.bodyFont.string;

};

export const formatDecimal = (value) => {
  return parseFloat(value).toFixed(1).replace('.', ',')
};


export const externalTooltipHandlerStacked = (context, myChart, dataArrays, addressAs, useAlternativeTotalsum) => 
{
  // Tooltip Element
  const {chart, tooltip} = context;

  const tooltipEl = getOrCreateTooltipCustom(chart);

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }

  // Set Text
  if (tooltip.body)
  {
    const bodyLines = tooltip.body.map(b => b.lines);
    var li = ``;

    bodyLines.forEach((b, i) => 
    {
      const colors = tooltip.labelColors[i];
      const myArray = b[0].split(":");

      // Account for decimals
      var pointValue = myArray[1].trim().replace(",", ".");

      // Calculate total
      if(tooltip.title)
      {
        let totalSum = 0;
        var labelName = tooltip.title[0];
        // Loop to find label index
        myChart.data.labels.forEach((label, index) =>
        {
          if(label == labelName)
          {
            const dataSalaries = dataArrays[index];

            let isFound = false;

            Object.keys(dataSalaries).forEach(key => 
            {
              if(isFound == false)
              {       
                // Convert to floating number
                var keyValue = parseFloat(dataSalaries[key]);

                var currentGroup = myArray[0].trim();

                totalSum += Math.round(keyValue);

                // Depending on how we want to display the total sum, either always show the total for all groups, or we only show total up to the selected group
                // useAlternativeTotalsum decides this
                if(!useAlternativeTotalsum)
                {
                  if(currentGroup == key)
                  {
                    isFound = true;
                  }
                }
              }
            });


            // round numbers
            totalSum = Math.round(totalSum);
            pointValue = Math.round(pointValue);


            // This is "delsektorer" where we want to show the 
            if(useAlternativeTotalsum)
            {
              li += `<li><span class="line-color" style="border-radius: 0px; background-color: ${colors.backgroundColor}"></span>${tooltip.title}s 
              <span class="type">${myArray[0].trim().toLowerCase()}</span> udgør ${pointValue} kr. i timen og de tjener i alt ${totalSum} kr. pr. time`;
            }
            else
            {
              li += `<li><span class="line-color" style="border-radius: 0px; background-color: ${colors.backgroundColor}"></span>${tooltip.title} ${addressAs ? addressAs : ""} 
              <span class="type">${myArray[0].trim().toLowerCase()}</span> tjener 

              ${totalSum == pointValue  ? "i alt" : ""} ${pointValue} kr. ${totalSum == pointValue  ? "i timen" : "mere"}`;
    
              if(totalSum > pointValue)
              {
                li += ` og tjener i alt ${totalSum} kr. i timen`
              }
            }

            li += `</li>`;
          }
        })
      }
    });

    const ul = document.createElement('ul');
    ul.innerHTML = li;

    const wrapper = tooltipEl.querySelector('.tooltip-content');

    // Remove old children
    while (wrapper.firstChild) {
      wrapper.firstChild.remove();
    } 

    // Add new children
    wrapper.appendChild(ul);
  }

  const {
    offsetLeft: positionX, 
    offsetTop: positionY
  } = chart.canvas;

  const slightOffset = 15;

  // Display, position, and set styles for font
  tooltipEl.style.opacity = 1;


  const tooltipSpace = chart.canvas.getBoundingClientRect().left + tooltip.caretX + tooltipEl.clientWidth;

  if(tooltipSpace < window.innerWidth)
  {
    tooltipEl.style.left = positionX + tooltip.caretX + slightOffset  + 'px';
  }
  else{
    tooltipEl.style.left = positionX + tooltip.caretX - slightOffset - 200 + 'px';;
  }

  tooltipEl.style.top = positionY + tooltip.caretY + 10 + 'px';  
  tooltipEl.style.font = tooltip.options.bodyFont.string;
};